import workspaceQuery from '../../../graphql/queries/company/CountryWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CountryListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CountryQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CountryDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CountryMutation.graphql';
import fragment from '../../../graphql/fragments/company/CountryFragment.graphql';

const Country = {
  type: 'Country',
  title: 'Country Codes',
  formTitle: 'Country Code',
  formUrl: '/Company/Country/Details/',
  workspaceUrl: '/Company/Country/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
  },
  fragment,
  screenReference: 'COUNTRY_CODES',
};

export default Country;
